// extracted by mini-css-extract-plugin
module.exports = {"MasterdataHeader":"MasterdataHeader_MasterdataHeader__366-f"};